import { Component, Input } from '@angular/core';

@Component({
    selector: 'senior-onboarding-info',
    templateUrl: './senior-onboarding-info.component.html',
    styleUrls: ['./senior-onboarding-info.component.scss'],
    standalone: false
})
export class SeniorOnboardingInfoComponent {
  @Input() isAssurant = false;
}
